export default __webpack_public_path__ + "static/media/time-line-default.29270576.svg";